import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as InfrastructureApiActions from "../actions/InfrastructureApiActions";
import {
  showModalWindow,
  removeModalWindow
  } from "../actions/WindowActions";


// Handle GUI for starting service.
function* requestStartService(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "StartServiceWindow", {serviceId: baseAction.serviceId}, "Start Service"));
  yield take([InfrastructureApiActions.START_SERVICE.CANCEL, InfrastructureApiActions.START_SERVICE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestStartService() {
  yield takeLatest(InfrastructureApiActions.REQUEST_START_SERVICE, requestStartService);
}

// Handle GUI for stopping service.
function* requestStopService(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "StopServiceWindow", {serviceId: baseAction.serviceId}, "Stop Service"));
  yield take([InfrastructureApiActions.STOP_SERVICE.CANCEL, InfrastructureApiActions.STOP_SERVICE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestStopService() {
  yield takeLatest(InfrastructureApiActions.REQUEST_STOP_SERVICE, requestStopService);
}

// Handle GUI for running service.
function* requestRunService(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RunServiceWindow", {serviceId: baseAction.serviceId}, "Run Service"));
  yield take([InfrastructureApiActions.RUN_SERVICE.CANCEL, InfrastructureApiActions.RUN_SERVICE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRunService() {
  yield takeLatest(InfrastructureApiActions.REQUEST_RUN_SERVICE, requestRunService);
}

export default function* infrastructureSaga() {
  yield fork(watchRequestStartService);
  yield fork(watchRequestStopService);
  yield fork(watchRequestRunService);
}
